const Style = {
    filesViewerContainer: 'flex flex-wrap justify-start items-start gap-2 w-full py-2 bg-white',
    fileWrapper: 'flex w-fit relative group',
    closeButton: 'absolute top-0 right-0 p-1 bg-red-500 text-white rounded-full hover:bg-red-600 transition-all duration-200 ease-in-out opacity-0 group-hover:opacity-100',
    imageWrapper: 'w-[100px] h-16 relative rounded-2xl group-hover:opacity-50',
    image: 'w-full h-full object-cover rounded-2xl shadow-md cursor-pointer transition-all duration-200 ease-in-out',
    textWrapper: 'w-full h-full overflow-hidden whitespace-nowrap overflow-ellipsis group',
};
export default Style;